import { render, staticRenderFns } from "./BackBtn.vue?vue&type=template&id=d2b34ad4"
import script from "./BackBtn.vue?vue&type=script&lang=ts"
export * from "./BackBtn.vue?vue&type=script&lang=ts"
import style0 from "./BackBtn.vue?vue&type=style&index=0&id=d2b34ad4&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports